import { InfoListTile } from '@varo/graphql-schema-types';
import { VXLGroupId, VXLNode } from 'shared/renderer/types';

import rowInfo from './rowInfo';
import { BorrowingPowerDependencies } from './types';

export default function infoListTile(
  list: InfoListTile,
  dependencies: BorrowingPowerDependencies,
): VXLNode {
  return {
    id: 'info-list',
    name: VXLGroupId.LIST_ITEM_GROUP,
    props: {
      items: list.rowItems.map((row) => rowInfo(row, dependencies)),
    },
  };
}
